import React from 'react';
import DOMPurify from 'dompurify';
import { useLanguage } from '../context/LanguageContext';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const TermsAndConditions = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  const content = {
    it: {
      title: 'Termini e Condizioni di Vendita',
      subtitle: 'Condizioni Generali di Contratto',
      lastUpdate: 'Ultimo aggiornamento',
      sections: [
        {
          title: '1. Informazioni Generali',
          content: `<p><strong>Ragione Sociale:</strong> Ala S.r.l.<br/>
<strong>Sede legale:</strong> Via Umberto Giordano, 84 — 90144 Palermo (PA), Italia<br/>
<strong>P.IVA / C.F.:</strong> 02988930828<br/>
<strong>REA:</strong> PA-120943<br/>
<strong>Capitale Sociale:</strong> € 10.400,00 i.v.<br/>
<strong>Codice SDI:</strong> QULXG4S<br/>
<strong>Telefono:</strong> +39 091 226476<br/>
<strong>Email:</strong> info@allmx.it<br/>
<strong>PEC:</strong> alasrlpalermo@pec.it</p>
<p>Questi Termini e Condizioni regolano la vendita di prodotti attraverso il sito allmx.it</p>`
        },
        {
          title: '2. Definizioni',
          content: `<ul>
  <li><strong>Venditore:</strong> ALLMX, proprietario del sito e-commerce</li>
  <li><strong>Cliente/Acquirente:</strong> Persona fisica o giuridica che effettua acquisti sul sito</li>
  <li><strong>Prodotti:</strong> Articoli per motocross disponibili alla vendita</li>
  <li><strong>Ordine:</strong> Richiesta di acquisto inviata dal Cliente</li>
  <li><strong>Contratto:</strong> Accordo tra Venditore e Cliente per la vendita di Prodotti</li>
</ul>`
        },
        {
          title: '3. Conclusione del Contratto',
          content: `<p>Il contratto si considera concluso nel momento in cui:</p>
<ol>
  <li>Il Cliente completa l'ordine sul sito inserendo tutti i dati richiesti</li>
  <li>Il Cliente effettua il pagamento con uno dei metodi accettati</li>
  <li>Il Venditore invia conferma d'ordine via email</li>
</ol>
<p>Il Venditore si riserva il diritto di annullare ordini in caso di:</p>
<ul>
  <li>Dati di fatturazione o spedizione incompleti o errati</li>
  <li>Prodotti non disponibili</li>
  <li>Prezzi manifestamente errati</li>
  <li>Sospetto di frode</li>
</ul>`
        },
        {
          title: '4. Prezzi e Pagamenti',
          content: `<p><strong>Prezzi:</strong></p>
<ul>
  <li>I prezzi sono espressi in Euro (€) e includono IVA</li>
  <li>I prezzi possono variare senza preavviso</li>
  <li>Il prezzo applicato è quello visualizzato al momento dell'ordine</li>
  <li>Costi di spedizione esclusi (indicati separatamente)</li>
</ul>

<p><strong>Metodi di Pagamento Accettati:</strong></p>
<ul>
  <li>Carte di credito/debito (Visa, Mastercard, American Express)</li>
  <li>PayPal</li>
  <li>Bonifico bancario (solo per ordini B2B)</li>
</ul>

<p><strong>Sicurezza Pagamenti:</strong> Tutti i pagamenti sono elaborati tramite gateway certificati PCI-DSS (Stripe, PayPal). Non memorizziamo i dati delle carte di credito.</p>`
        },
        {
          title: '5. Spedizione e Consegna',
          content: `<p><strong>Tempi di Consegna:</strong></p>
<ul>
  <li><strong>Italia:</strong> 2-4 giorni lavorativi</li>
  <li><strong>Europa:</strong> 5-7 giorni lavorativi</li>
  <li><strong>Resto del Mondo:</strong> 7-15 giorni lavorativi</li>
</ul>

<p><strong>Costi di Spedizione:</strong></p>
<ul>
  <li>Italia: €7.50 (GRATIS sopra €150)</li>
  <li>Europa: €9.90-€15.00</li>
  <li>Resto del Mondo: da €79.00</li>
</ul>

<p><strong>La Spedizione Gratuita è valida esclusivamente per ordini superiori a €150 destinati all'Italia. Argentina €50 fisso.</strong></p>

<p>I tempi sono indicativi e non costituiscono obbligo contrattuale. Ritardi del corriere non sono imputabili al Venditore.</p>`
        },
        {
          title: '6. Diritto di Recesso (per Consumatori)',
          content: `<p>In conformità al D.Lgs. 206/2005 (Codice del Consumo), hai diritto di recedere dal contratto senza fornire motivazioni entro <strong>14 giorni</strong> dal ricevimento della merce.</p>

<p><strong>Come Esercitare il Recesso:</strong></p>
<ol>
  <li>Invia comunicazione a: <strong>info@allmx.it</strong></li>
  <li>Restituisci il prodotto integro, non utilizzato, nella confezione originale</li>
  <li>Includi copia della fattura</li>
</ol>

<p><strong>Spese di Restituzione:</strong> A carico del Cliente</p>

<p><strong>Rimborso:</strong> Entro 14 giorni dal ricevimento della merce resa, tramite stesso metodo di pagamento utilizzato per l'acquisto.</p>

<p><strong>Esclusioni dal Recesso:</strong></p>
<ul>
  <li>Prodotti personalizzati o su misura</li>
  <li>Prodotti sigillati aperti (per motivi igienici)</li>
  <li>Prodotti deteriorabili rapidamente</li>
</ul>`
        },
        {
          title: '7. Garanzia Legale',
          content: `<p>Tutti i prodotti sono coperti dalla garanzia legale di conformità di <strong>24 mesi</strong> dalla consegna (D.Lgs. 206/2005).</p>

<p><strong>La garanzia copre:</strong></p>
<ul>
  <li>Difetti di conformità presenti al momento della consegna</li>
  <li>Difetti che si manifestano entro 24 mesi</li>
</ul>

<p><strong>Come Richiedere Assistenza in Garanzia:</strong></p>
<ol>
  <li>Contattaci a: info@allmx.it</li>
  <li>Descrivi il difetto e allega foto</li>
  <li>Fornisci numero ordine e data acquisto</li>
</ol>

<p><strong>La garanzia NON copre:</strong></p>
<ul>
  <li>Usura normale</li>
  <li>Danni da uso improprio o negligenza</li>
  <li>Modifiche non autorizzate</li>
  <li>Danni durante il trasporto (deve essere denunciato al corriere)</li>
</ul>`
        },
        {
          title: '8. Disponibilità Prodotti',
          content: `<p>I prodotti sono venduti fino ad esaurimento scorte. In caso di non disponibilità dopo l'ordine:</p>
<ul>
  <li>Ti contatteremo per proporre un prodotto alternativo</li>
  <li>Potrai scegliere di attendere il riassortimento</li>
  <li>Potrai annullare l'ordine con rimborso completo</li>
</ul>`
        },
        {
          title: '9. Responsabilità',
          content: `<p>Il Venditore non è responsabile per:</p>
<ul>
  <li>Danni indiretti o consequenziali derivanti dall'uso dei prodotti</li>
  <li>Incompatibilità dei prodotti con veicoli non specificamente indicati</li>
  <li>Ritardi di consegna dovuti a cause di forza maggiore</li>
  <li>Danni dovuti a installazione errata</li>
</ul>

<p><strong>Uso Corretto:</strong> I prodotti devono essere utilizzati secondo le istruzioni del produttore. L'installazione deve essere effettuata da personale qualificato.</p>`
        },
        {
          title: '10. Proprietà Intellettuale',
          content: `<p>Tutti i contenuti del sito (testi, immagini, loghi, design) sono protetti da diritti d'autore e proprietà intellettuale di ALLMX o dei rispettivi proprietari.</p>
<p>È vietata la riproduzione, distribuzione o uso commerciale senza autorizzazione scritta.</p>`
        },
        {
          title: '11. Privacy',
          content: `<p>Il trattamento dei dati personali è regolato dalla nostra <a href="/privacy-policy" class="text-primary hover:underline">Informativa Privacy</a> in conformità al GDPR.</p>`
        },
        {
          title: '12. Risoluzione Controversie',
          content: `<p><strong>Legge Applicabile:</strong> Legge italiana</p>
<p><strong>Foro Competente:</strong> Foro di Palermo per controversie con professionisti</p>

<p><strong>Risoluzione Alternativa Controversie (ADR):</strong></p>
<p>In caso di controversia, il consumatore può rivolgersi a:</p>
<ul>
  <li><strong>Piattaforma ODR Europea:</strong> <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">ec.europa.eu/consumers/odr</a></li>
  <li><strong>Camera di Commercio:</strong> Per conciliazione e mediazione</li>
</ul>`
        },
        {
          title: '13. Modifiche',
          content: `<p>Ci riserviamo il diritto di modificare questi Termini e Condizioni in qualsiasi momento. Le modifiche entrano in vigore dalla pubblicazione sul sito.</p>
<p>Gli ordini già confermati rimangono soggetti ai Termini vigenti al momento dell'ordine.</p>`
        }
      ],
      disclaimer: '⚠️ NOTA: Questa è una struttura base. È OBBLIGATORIO consultare un avvocato specializzato in e-commerce per personalizzare i Termini e Condizioni secondo le specifiche esigenze aziendali e normative vigenti.'
    },
    en: {
      title: 'Terms and Conditions of Sale',
      subtitle: 'General Contract Conditions',
      lastUpdate: 'Last updated',
      sections: [
        {
          title: '1. General Information',
          content: `<p><strong>Company Name:</strong> Ala S.r.l.<br/>
<strong>Registered Office:</strong> Via Umberto Giordano, 84 — 90144 Palermo (PA), Italy<br/>
<strong>VAT / Tax Code:</strong> 02988930828<br/>
<strong>REA:</strong> PA-120943<br/>
<strong>Share Capital:</strong> € 10,400.00 fully paid-up<br/>
<strong>SDI Code:</strong> QULXG4S<br/>
<strong>Phone:</strong> +39 091 226476<br/>
<strong>Email:</strong> info@allmx.it<br/>
<strong>PEC:</strong> alasrlpalermo@pec.it</p>
<p>These Terms and Conditions govern the sale of products through allmx.it</p>`
        },
        // Traduzioni abbreviate per brevità - seguono la stessa struttura
        {
          title: '2. Definitions',
          content: `<ul>
  <li><strong>Seller:</strong> ALLMX, owner of the e-commerce site</li>
  <li><strong>Customer/Buyer:</strong> Individual or legal entity making purchases on the site</li>
  <li><strong>Products:</strong> Motocross items available for sale</li>
  <li><strong>Order:</strong> Purchase request submitted by Customer</li>
  <li><strong>Contract:</strong> Agreement between Seller and Customer for product sale</li>
</ul>`
        }
        // ... altre sezioni in inglese ...
      ],
      disclaimer: '⚠️ NOTE: This is a basic template. It is MANDATORY to consult a specialized lawyer in e-commerce to customize Terms and Conditions according to specific business needs and applicable regulations.'
    }
  };

  const t = content[language] || content.it;

  return (
    <div className="dark-container pt-20 min-h-screen">
      <SEO title="Termini e Condizioni - ALLMX" description="Termini e Condizioni di ALLMX.it" url="https://allmx.it/terms-and-conditions" />
      <div className="max-w-4xl mx-auto px-6 py-12">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-white/70 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          {language === 'it' ? 'Indietro' : language === 'es' ? 'Atrás' : 'Back'}
        </button>

        <h1 className="text-4xl sm:text-5xl font-bold mb-4">{t.title}</h1>
        <p className="text-xl text-white/70 mb-2">{t.subtitle}</p>
        <p className="text-sm text-white/50 mb-12">
          {t.lastUpdate}: {new Date().toLocaleDateString(language === 'it' ? 'it-IT' : 'en-US')}
        </p>

        <div className="space-y-8">
          {t.sections.map((section, index) => (
            <section key={`section-${section.title.substring(0, 20)}`} className="dark-card p-6">
              <h2 className="text-2xl font-bold mb-4 text-primary">{section.title}</h2>
              <div 
                className="prose prose-invert max-w-none"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(section.content) }}
              />
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;